'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _decorators = require('../utils/propTypes/decorators');

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var emptyBox = _react2.default.createElement('span', null);

var maxHeightForSize = {
  sm: 10,
  md: 50,
  lg: 90
};

var getGrippieBackground = (0, _memoize2.default)(function (fill) {
  var svgStr = '<svg width=\'' + _sizes.DRAG_HANDLE_WIDTH + '\' height=\'' + _sizes.DRAG_HANDLE_HEIGHT + '\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 ' + _sizes.DRAG_HANDLE_WIDTH + ' ' + _sizes.DRAG_HANDLE_HEIGHT + '\'><path fill=\'' + fill + '\' d=\'M0 0h2v2H0V0zm0 8h2v2H0V8zm0 8h2v2H0v-2zM0 4h2v2H0V4zm0 8h2v2H0v-2zm0 8h2v2H0v-2zM3 0h2v2H3V0zm0 8h2v2H3V8zm0 8h2v2H3v-2zM3 4h2v2H3V4zm0 8h2v2H3v-2zm0 8h2v2H3v-2z\'/></svg>';
  return (0, _styledComponents.css)(['background-image:url("data:image/svg+xml,', '");'], encodeURIComponent(svgStr));
});

var getGrippieOffset = (0, _memoize2.default)(function (offsetX) {
  return (0, _styledComponents.css)(['background-position:', ' calc(50% + 1px);background-repeat:no-repeat;'], offsetX);
});

var standaloneMixin = (0, _styledComponents.css)(['display:inline-block;line-height:', ';min-width:', ';&::after{content:\'.\';visibility:hidden;}'], _sizes.BASE_LINE_HEIGHT, _sizes.DRAG_HANDLE_WIDTH);

var sizedMixin = (0, _styledComponents.css)(['background-image:none !important;position:relative;&::before{content:\' \';', ';background-repeat:repeat-y;position:absolute;', ':', ';top:0;width:', ';height:calc(100% - ', ');max-height:', 'px;margin:', ' 0;}'], getGrippieBackground(_colors.SLINKY), function (_ref) {
  var trailing = _ref.trailing;
  return trailing ? 'right' : 'left';
}, _sizes.DRAG_HANDLE_OFFSET_X, _sizes.DRAG_HANDLE_WIDTH, _sizes.DRAG_HANDLE_HEIGHT, function (_ref2) {
  var size = _ref2.size;
  return maxHeightForSize[size];
}, _sizes.DRAG_HANDLE_OFFSET_Y);

var DragHandleChild = (0, _styledComponents2.default)(function (_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      rest = _ref3.rest;

  return (0, _react.cloneElement)(children, _extends({
    className: (0, _classnames2.default)(children.props.className, className)
  }, rest));
}).withConfig({
  displayName: 'UIDragHandle__DragHandleChild'
})(['', ';', ' ', ';', ';', ''], (0, _Styles.setGrabCursor)(), function (_ref4) {
  var use = _ref4.use;
  return getGrippieBackground(use === 'on-dark' ? _colors.OLAF : _colors.SLINKY);
}, function (_ref5) {
  var standalone = _ref5.standalone,
      trailing = _ref5.trailing;

  var offsetX = _sizes.DRAG_HANDLE_OFFSET_X;
  if (standalone && trailing) {
    offsetX = '0';
  } else if (standalone) {
    offsetX = '50%';
  }
  if (trailing) offsetX = 'calc(100% - ' + offsetX + ')';
  return getGrippieOffset(offsetX);
}, function (_ref6) {
  var standalone = _ref6.standalone;
  return standalone && standaloneMixin;
}, function (_ref7) {
  var size = _ref7.size;
  return size !== 'default' && sizedMixin;
});

function UIDragHandle(props, context) {
  var children = props.children,
      className = props.className,
      position = props.position,
      size = props.size,
      use = props.use,
      _wrappedWithDnd = props._wrappedWithDnd,
      rest = _objectWithoutProperties(props, ['children', 'className', 'position', 'size', 'use', '_wrappedWithDnd']);

  var connectDragSource = context.connectDragSource;


  if (process.env.NODE_ENV !== 'production') {
    if (typeof connectDragSource === 'function' && !_wrappedWithDnd) {
      _devLogger2.default.warn({
        key: 'UIDragHandle: addon',
        message: 'Looks like you’re trying to use UIComponents’ `UIDragHandle` with ui-addon-draggable. Use `ui-addon-draggable/draggable/UIDragHandle` instead.'
      });
    }
  }

  return _react2.default.createElement(
    DragHandleChild,
    {
      className: (0, _classnames2.default)(className, 'is--draggable', {
        'is--draggable--sized': size !== 'default'
      }),
      rest: rest,
      size: (0, _tshirtSize.toShorthandSize)(size),
      standalone: children === emptyBox,
      trailing: position === 'end',
      use: use
    },
    children
  );
}

UIDragHandle.defaultProps = {
  children: emptyBox,
  position: 'start',
  size: 'default',
  use: 'default'
};

UIDragHandle.propTypes = {
  children: _propTypes2.default.element.isRequired,
  position: _propTypes2.default.oneOf(['start', 'end']).isRequired,
  size: _propTypes2.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg']), _propTypes2.default.oneOf(['default'])]).isRequired,
  use: _propTypes2.default.oneOf(['default', 'on-dark']).isRequired,
  _wrappedWithDnd: (0, _decorators.hidden)(_propTypes2.default.bool)
};

UIDragHandle.contextTypes = {
  connectDragSource: _propTypes2.default.func
};

UIDragHandle.displayName = 'UIDragHandle';

exports.default = UIDragHandle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/draggable/UIDragHandle.js
// module id = 594
// module chunks = 177